import { Component, Input } from '@angular/core';
import { HlCurrencyPipe } from '../../pipes/hl-currency.pipe';
import { TestIdDirective } from '../../directives/test-id.directive';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-price-container-line',
  template: ` <div class="flex flex-row w-full">
    <div class="flex flex-shrink-0 w-1/2">
      <p>
        <strong>{{ name }}</strong>
      </p>
    </div>
    <div class="flex flex-shrink-0 w-1/2 flex-row">
      <ngx-skeleton-loader
        class="w-full"
        *ngIf="loading; else valueContainer"
        [count]="1"
      ></ngx-skeleton-loader>
      <ng-template #valueContainer>
        <p class="flex-grow text-right" [testId]="key ?? name">
          {{ value | hlCurrency: currency : currencyRate | async }}
        </p>
      </ng-template>
    </div>
  </div>`,
  standalone: true,
  imports: [
    NgIf,
    NgxSkeletonLoaderModule,
    TestIdDirective,
    AsyncPipe,
    HlCurrencyPipe
  ],
  styles: [
    `
      :host {
        width: 100%;
      }
    `
  ]
})
export class PriceContainerLineComponent {
  @Input() currency = null;
  @Input() currencyRate = 1;
  @Input() name: string;
  @Input() loading = true;
  @Input() value: number;
  @Input() key: string;

  constructor() {}
}
